import CashPayment from "./CashPayment";
export default CashPayment;
